import { render, staticRenderFns } from "./SmsCode.vue?vue&type=template&id=b94cf822&scoped=true&"
import script from "./SmsCode.vue?vue&type=script&lang=js&"
export * from "./SmsCode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b94cf822",
  null
  
)

export default component.exports